<template>
    <div v-cloak>


        <el-steps :active="1" align-center>
            <el-step :title="$t('LinkAutoTable.selectTemplate')" :description="$t('LinkAutoTable.pleaseSelectConfigYouNeed')">
            </el-step>
            <el-step :title="$t('LinkAutoTable.uploadFile')" :description="$t('LinkAutoTable.pleaseUploadCorrectFile')">
            </el-step>
            <el-step :title="$t('LinkAutoTable.validateImportData')" :description="$t('LinkAutoTable.pleaseCheckDataToBeImport')">
            </el-step>
            <el-step :title="$t('LinkAutoTable.checkResult')" :description="$t('LinkAutoTable.pleaseCheckResultAndErrorData')">
            </el-step>
        </el-steps>

        <div class="main" style="margin-top:50px;">
            <el-row>
                <el-col :span="4">
                    <div class="grid-content">

                    </div>
                </el-col>
                <el-col :span="16">
                    <div class="grid-content ">
                        <span v-html="main_comments"></span>

                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="grid-content ">

                    </div>
                </el-col>
            </el-row>

            <el-row type="flex">
                <el-col :span="4">
                    <div class="grid-content">

                    </div>
                </el-col>
                <el-col :span="16">
                    <div class="grid-content " style="min-height:150px;">
                        <el-upload
                                :data="customerData"
                                :auto-upload="false"
                                ref="upload"
                                :headers="headers"
                                class="upload-demo"
                                :action="path"
                                :on-preview="handlePreview"
                                :on-remove="handleRemove"
                                :on-success="handleUploadSuccess"
                                :on-error="handleUploadError"
                                :before-remove="beforeRemove"
                                multiple
                                :limit="30"
                                :on-exceed="handleExceed"
                                :file-list="fileList">
                            <el-button size="small" type="primary">{{$t('LinkAutoTable.clickToSelectFile')}}</el-button>
                            <div style="display: inline;margin-left: 10px;" slot="tip" class="el-upload__tip">
                                {{$t('LinkAutoTable.importTips')}}
                            </div>
                        </el-upload>

                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="grid-content ">

                    </div>
                </el-col>
            </el-row>

            <el-row class="button" v-if="!importDialog">
                <el-button type="primary" size="mini" @click="laststep()">{{$t('LinkAutoTable.prevStep')}}</el-button>
                <el-button v-if="canBackgroudrun === 'Y'" type="primary" size="mini" @click="bgrun()">{{$t('LinkAutoTable.executeBackground')}}</el-button>
                <el-button v-else type="primary" size="mini" @click="nextstep()">{{$t('LinkAutoTable.nextStep')}}</el-button>
            </el-row>
        </div>


    </div>
</template>

<script>
	import DataStore from './data.store'
    export default {
        name: 'step2',
        data: function () {
            return {
                // configId: this.pageParam.id, // 配置的ID，需要第一个界面传入的。
                path: LinkVue.publicImportUrlprefix + 'handpublicimport',
                main_comments: '',
                active: 1,
                showFastSearch: true, // 显示快速筛选框
                item: [], // 列表
                config: {}, // 配置对象
                currentPage: 1, // 当前页数
                pagesize: 6, // 每页显示的数量
                searchKeywords: '', // 查询筛选框
                loadSuccess: false, // 首次数据加载是否完成标记. 避免与watch的数据冲突
                fileList: [],
                form: '',
                headers: {Authorization: linkToken.getLocalToken()},
                customerData: {
                    // configId: linkTools.getQueryString('id'),
                    configId: this.configId ? this.configId : this.pageParam.id,
                    bgflag: 'N',
                    host: this.context.$http.baseURL,
                    flaskhost: LinkVue.publicImportUrlprefix
                },
                fieldTypeConfig: '', // 字段类型配置，传递给后台服务，使得读取返回的内容合规
                canBackgroudrun: '', // 是否可后台运行
                radio2: ''
            };
        },
        created: function () {
            DataStore.currentSelectId = this.configId ? this.configId : this.pageParam.id;
            DataStore.pubdataImportconfig = {};// 临时存放当前所使用的配置
            // DataStore.tmpPublicImportData={};//临时存放导入数据对象的变量
            this.queryConfigId();
        }, // 创建时触发
        props: {
            configId: {type: String},
            importDialog: {type: Boolean, default: false},
		  	context: Object
        },
        watch: {}, // 监控变量变动
        methods: {
            async queryConfigId() {
                try {
                    const data = await this.context.$http.post(`${LinkVue.prefixUrl}/publicdataimport/queryById`, {id: this.configId ? this.configId : this.pageParam.id}, true);
                    if (data.success) {
                      this.config = data.result.config ? JSON.parse(data.result.config) : {field: []};
                      this.canBackgroudrun = data.result.isBackImport; // 字段更新，attr01->isBackImport

                        // this.canBackgroudrun = data.result.attr01;
                        DataStore.pubdataImportconfig = this.config;
                        DataStore.name = data.result.name;
                        if (DataStore.pubdataImportconfig) {
                            this.fieldTypeConfig += '{';
                            for (var i = 0; i < this.config.field.length; i++) {
                                if (this.config.field[i].valueType && this.config.field[i].valueType !== 'auto') {
                                    this.fieldTypeConfig += 'u"' + this.config.field[i].name + '":' + this.config.field[i].valueType + ',';
                                }
                            }
                            this.fieldTypeConfig += '}';
                            this.fieldTypeConfig = this.fieldTypeConfig.replace(',}', '}').replace('{}', '');
                            this.customerData.fieldTypeConfig = this.fieldTypeConfig;
                        }
                    } else {
                        this.$nav.error('获取失败:' + data.result);

                    }
                } catch (e) {

                    this.$nav.error('请求出现错误:' + e);
                }


            },

            /**
             * 下一步
             */
            laststep: function () {
                // gotoContentPage(appCtx.cdnPath + '/linkcrm/public_data_management/step1.html');
                this.$nav.push('/modules/crm/public_data_management/public_data_manage/step1.vue');
            },

            nextstep: function () {
                this.customerData.bgflag = 'N';
                this.$refs.upload.submit();
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log(file);
            },
            handleExceed(files, fileList) {
                this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },
            beforeRemove(file, fileList) {
                return this.$confirm(`确定移除 ${file.name}？`);
            },
            handleUploadError() {
                this.$message({
                    showClose: true,
                    message: '上传文件失败，请联系管理人员！',
                    type: 'error'
                });
            },
            handleUploadSuccess(response, file, fileList) {
                if (!this.importDialog) {
                    if (!this.importDialog && this.customerData.bgflag == 'Y') {
                        this.$notify({
                            title: '提交成功',
                            message: '成功提交到后台，请在导入任务中进行查看！',
                            type: 'success'
                        });
                        setTimeout(() => {
                            this.$nav.push('/modules/crm/public_data_management/public_data_manage/data-task-list.vue');
                        }, 2000);
                    } else {
                        DataStore.tmpPublicImportData = response;
                        this.$nav.push('/modules/crm/public_data_management/public_data_manage/step3.vue');
                    }
                } else {
                    DataStore.tmpPublicImportData = response;
                    this.$emit('uploadSuccess');
                }
            },
            bgrun: function () {
                this.customerData.bgflag = 'Y';
                /*
                if (this.fileList.length==0){
                    this.$message({
                        showClose: true,
                        message: '请点击选择文件按钮选择需要处理的文件！',
                        type: 'error'
                    });
                }
                */
                this.$refs.upload.submit();
            }
        }
    };
</script>

<style scoped>

    .main .button {
        margin-top: 30px;
        vertical-align: middle;
        text-align: center;

    }

    button {
        border-radius: 0 !important;
    }
</style>
